import { NoopFinishStep } from './NoopFinishStep';
import { MFASetup } from './MFASetup';
import { RememberThisDevice } from './RememberThisDevice';
import { PasswordSetup } from './PasswordSetup';
import { Default } from './Default';

const templateMap = {
  UserAuthPasswordSetupStep: PasswordSetup,
  UserAuthMFASetupStep: MFASetup,
  UserAuthRememberMeSetupStep: RememberThisDevice,
  NoopFinishStep,
};

export const getTemplate = (resource) => {
  const template = templateMap[resource.meta().type()];

  if (!template) {
    return Default;
  }

  return template;
};
